"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.search.failed': 'Impossibile cercare nei log DB. Riprova.',
};
